import { defineComponent } from "vue";
import VueCookie from 'vue-cookie'
import { useToast } from "vue-toastification";
import dashboardService from "@/services/dashboard.service";
import dateFormatService from "@/services/date-format.service";

export default defineComponent({
   name: "dashboard",
   setup() {
        const toast = useToast();
         return { toast }
   },
   mounted() {
        this.customerId = VueCookie.get("cid");
        this.getDashboardDetails();
   },
   data() {
      return {
         totalOrders: 0,
         customerId: '',
         orders: [],
         quotation: [],
         expiry_days: 0,
         firstOrder: {
            sum_insured_to:'',
            sum_insured_from:''
         },
      };
   },
   methods: {
      getDashboardDetails() {
         const loader = this.$loading.show();
         const today = new Date();
         dashboardService
            .getDashboardDetails(this.customerId)
            .then((res) => {
                loader.hide();
                this.orders = Object.freeze(res.orders);
                this.quotation = Object.freeze(res.quotations);
                this.firstOrder = Object.freeze(this.orders[0]);
                this.expiry_days = this.diffDateDays(today,this.firstOrder.sum_insured_to);
            })
            .catch((err) => {
               loader.hide();
               this.toast.error(err.response.statusText);
               console.log(err);
            });
      },
      formatDatePeriod(date: string) {
         return dateFormatService.formatDatePeriod(date);
      },
      formatDate(date: string) {
         return dateFormatService.formatDate(date);
      },
      diffDateDays(dateTo = null,dateFrom = null){
         return dateFormatService.diffDateDays(dateTo,dateFrom);
      }
   },
});
